export default () => {
  let searchToggle = document.querySelector('.mainHeader__searchIcon');
  let searchBar    = document.querySelector('.searchBar');
  let mainHeader   = document.querySelector('.mainHeader');
  let wrapperClose = document.querySelector('.mainHeader__searchBar');

  let activeSearchClass = "open-search";
  let iconSearch        = "icon-search";
  let iconClose         = "icon-cross";

  searchToggle?.addEventListener('click', () => {
    toggleSearch();
  });

  wrapperClose?.addEventListener('click', () => {
    if (mainHeader.classList.contains(activeSearchClass)) {
      toggleSearch();
    }
  });

  searchBar?.addEventListener('click', e => {
    e.stopPropagation();
  });

  function toggleSearch() {
    //searchBar.value = null;
    mainHeader.classList.toggle(activeSearchClass);
    searchToggle.classList.toggle(iconSearch);
    searchToggle.classList.toggle(iconClose);
  }
}